import { useState } from "react";
import { Tooltip } from '@heroui/tooltip';
import { ImageBrokenIcon, ClipboardTextIcon } from "@phosphor-icons/react";
const ImageNotFound = (props: {
  id: number;
  src: string;
  isThumbnail?: boolean;
}) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(props.src).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    });
  };
  return <div className={`flex flex-col items-center justify-center w-auto h-auto ${props.isThumbnail ? '' : 'p-[30px]'}`} data-sentry-component="ImageNotFound" data-sentry-source-file="imageNotFound.tsx">
      <Tooltip content={<div className="flex flex-col gap-1 items-start justify-start w-full h-auto">
            <textarea className="w-full h-auto line-clamp-1 p-1 bg-white/20 rounded-sm border border-black/5 border-dashed resize-none overflow-y-scroll" value={props.src} readOnly />
            <div className={`h-fit w-fit btn-h bg-transparent transition-colors duration-300 rounded-sm p-0 m-0 mr-[-6px] cursor-pointer [&>*]:cursor-pointer ${copied ? 'bg-brand-blue hover:bg-brand-blue' : 'hover:bg-tooltip-bg'}`} onClick={handleCopy}>
              <ClipboardTextIcon weight="duotone" size={20} />
            </div>
          </div>} offset={-5} closeDelay={100} showArrow={true} classNames={{
      content: 'w-[300px] h-auto break-all wrap bg-tooltip-bg text-white',
      base: 'before:bg-tooltip-bg'
    }} data-sentry-element="Tooltip" data-sentry-source-file="imageNotFound.tsx">
        <div className="flex flex-col items-center justify-center hover:cursor-help min-w-[60px] min-h-[60px]">
          <ImageBrokenIcon weight={props.isThumbnail ? 'thin' : 'duotone'} size={props.isThumbnail ? 60 : 100} data-sentry-element="ImageBrokenIcon" data-sentry-source-file="imageNotFound.tsx" />
          {!props.isThumbnail && <div className="text-white/65 text-lg">Image not found or empty</div>}
        </div>
      </Tooltip>
    </div>;
};
export default ImageNotFound;